import { createSlice } from "@reduxjs/toolkit";
import { getAllProformaInvoice, getProformaInvoiceById } from "../api/proformaInvoice";

interface UsersState {
    loading: boolean;
    currentRequestId: undefined | string;
    userData: any;
    error: any;
}

const initialState = {
    loading: false,
    currentRequestId: undefined,
    userData: null,
    error: null,
} as UsersState;

export const proformaInvoiceSlice = createSlice({
    name: 'proformaInvoice',
    initialState,
    reducers: {
        resetProformaInvoice: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(getAllProformaInvoice.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getAllProformaInvoice.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(getAllProformaInvoice.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
            .addCase(getProformaInvoiceById.pending, (state, action) => {
                state.loading = true;
                state.currentRequestId = action.meta.requestId;
            })
            .addCase(getProformaInvoiceById.fulfilled, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                }
            })
            .addCase(getProformaInvoiceById.rejected, (state, action) => {
                const { requestId } = action.meta;
                if (state.loading && state.currentRequestId === requestId) {
                    state.loading = false;
                    state.currentRequestId = undefined;
                    state.error = action.error;
                }
            })
    }
})

export const { resetProformaInvoice } = proformaInvoiceSlice.actions;

export default proformaInvoiceSlice.reducer;
